import React from 'react'
import Loadable from "react-loadable";
import LoadingPage from "../../../LoadingPage";

const DetailChartWrapperLazy = Loadable({
  loader: () => import('./DetailChartWrapper'),
  loading: LoadingPage
})

const DetailChartWrapper = (props) => (
  <DetailChartWrapperLazy {...props} />
)

export default DetailChartWrapper
